// InviteFriendRulesItem.tsx
import React, { useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import useMeasure from "react-use-measure";
import ArrowDown from "assets/icons/arrow-down-small.svg?react";
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";

const InviteFriendRulesItem = ({ rule }) => {
  const [open, setOpen] = useState(false);
  const [contentRef, bounds] = useMeasure();
  const t = useTranslate();
  const expand = useSpring({
    height: open ? bounds.height : 0,
    opacity: open ? 1 : 0,
    overflow: "hidden",
  });

  return (
    <div className="InviteFriendRulesItem">
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        className="InviteFriendRulesItem__btn"
        onClick={() => setOpen(!open)}
      >
        <span className="InviteFriendRulesItem__title">{t(rule.title)}</span>
        <ArrowDown
          className={`InviteFriendRulesItem__arrow ${open ? "active" : ""}`}
        />
      </button>
      <animated.div style={expand} className="InviteFriendRulesItem-content">
        <div
          className="InviteFriendRulesItem-content-list"
          ref={open ? contentRef : undefined}
        >
          {rule.description.map((desc) => (
            <li className="InviteFriendRulesItem-content-list__desc" key={desc}>
              {t(desc)}
            </li>
          ))}
          {rule.nestedItems?.map((nestedItem) => (
            <div key={nestedItem.id} className="InviteFriendRulesItem-nested">
              <div className="InviteFriendRulesItem-nested__title">
                {t(nestedItem.title)}
              </div>
              {nestedItem.description.map((desc) => (
                <li
                  className="InviteFriendRulesItem-content-list__desc"
                  key={desc}
                >
                  {t(desc)}
                </li>
              ))}
            </div>
          ))}
        </div>
      </animated.div>
    </div>
  );
};

export default InviteFriendRulesItem;
